import React, { useState, useEffect } from 'react';

export default function LMPayments(props) {
    return <div>Payments</div>;
}
